import QumanoLogService from '@/modules/general/g--qumano/service.js';
import ProductsService from '@/modules/general/g--products/service.js';
export const B__RecommendedProducts = () => ({
    qumanoIsActive: false,
    qumanoIsLoading: false,
    spinnerStatus: 'idle',
    pdfs: [],
    products: [],
    init() {
        this.setSpinnerStatus('loading'); // show spinner

        this.getRecommendedProducts().then((res) => {
            this.setSpinnerStatus('done'); // show spinner

            this.products = res;

            const primaryProduct = res[0];

            const scenarioData = JSON.parse(
                localStorage.getItem('qumano-scenario-data')
            );

            // Replace hero text - setTimeout needed to let it render the hero first (requires this.products to render in the first place)
            setTimeout(() => {
                document.querySelector('.b--section-title .e--text').innerHTML =
                    scenarioData.text;

                document.querySelector('.b--hero-product .e--text').innerHTML =
                    scenarioData.teaser;

                const heroImageElement = document.querySelector(
                    '.b--hero-product .e--image img'
                );
                heroImageElement.srcset =
                    primaryProduct.acf.e__image_1.image.sizes['2k'];

                setTimeout(() => {
                    heroImageElement.style.opacity = 1;
                }, 100);
            }, 1000);
        });
    },

    addPdfUrls(pdfs) {
        this.pdfs = pdfs;
    },

    downloadPdf(pdf_WP_Object) {
        const pdfElement = document.createElement('a');
        pdfElement.href = pdf_WP_Object.url;
        pdfElement.download = pdf_WP_Object.filename;
        document.body.appendChild(pdfElement);
        pdfElement.click();
        document.body.removeChild(pdfElement);
    },

    setSpinnerStatus(status) {
        this.spinnerStatus = status;

        if (status == 'done') {
            setTimeout(() => {
                this.spinnerStatus = 'idle';
            }, 800);
        }
    },

    initiate() {
        if (window.qumano) {
            if (!this.qumanoIsActive) {
                this.qumanoIsLoading = true;

                setTimeout(() => {
                    window
                        .qumano({
                            API_KEY: 12341234,
                            elemSelector: '#qumano-widget-app',
                            id: 1,
                            flowId: 3,
                            appPath:
                                window.location.origin +
                                '/app/themes/umano/modules/general/g--qumano/app'
                        })
                        .then((res) => {
                            // console.log(res);
                            this.qumanoIsActive = true;
                            this.qumanoIsLoading = false;

                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        });

                    window.addEventListener('qumano-pdf-ready', (e) => {
                        console.log('qumano- donwload PDF client event');

                        const appState = e.detail.appState;

                        // appState.scenarios.forEach((scenario) => {
                        //     console.log(scenario)
                        // });

                        // update Localstorage
                        // localStorage.setItem(
                        //     'qumano-checkout',
                        //     JSON.stringify(appState)
                        // );

                        const scenarioData = JSON.parse(
                            localStorage.getItem('qumano-scenario-data')
                        );

                        if (
                            scenarioData.wp_acf_key &&
                            this.pdfs[scenarioData.wp_acf_key]
                        ) {
                            this.downloadPdf(
                                this.pdfs[scenarioData.wp_acf_key]
                            );
                        } else {
                            console.warn(
                                'PDF was not found in the list of PDFs'
                            );
                        }
                        // get Localstorage
                        const wpLogId =
                            localStorage.getItem('qumano-wp-log-id');

                        QumanoLogService.update({
                            action: 'finished',
                            flow: 3,
                            appState: appState,
                            wpLogId: wpLogId
                        }).then((res) => {
                            // console.log(res);

                            // remove Localstorage
                            // localStorage.removeItem('qumano-wp-log-id');

                            // remove Localstorage
                            localStorage.removeItem(
                                'recommended-products-from-qumano'
                            );

                            this.qumanoIsActive = false;
                        });
                    });
                }, 500);
            }
        }
    },

    isQumanoFlowInitiatorButton() {
        this.initiate();
    },

    getWpProduct(recommendedProductsAsString) {
        /**
         * Keys must match values from Quamno API
         */
        const mapToWpProductsIds = {
            Qube: 32, // Qube 384
            QP16: 36, // QPatch ( notice 16 edition issue)
            QP48: 36, // QPatch ( notice 48 edition issue)
            QPC: 35 // QPatch Compact
        };

        const WP_product_id = mapToWpProductsIds[recommendedProductsAsString];

        return WP_product_id;
    },
    async getRecommendedProducts() {
        const recommendations = JSON.parse(
            localStorage.getItem('recommended-products-from-qumano')
        );

        if (!recommendations) {
            return;
        }

        const productIds = recommendations.map((recomendation) => {
            return this.getWpProduct(recomendation);
        });

        // console.log(productIds);
        const res = await ProductsService.get({ productIds: productIds });
        return res;
    }
});
